import {getRefreshToken, getTokenFromSession, refreshIdToken} from "../services/authenticate";
import axiosInstance from "../axiosInstance";
import {api} from "../api";

export const getExistingTheme = async () => {
    const token = getTokenFromSession()
    try {
        return await axiosInstance.get(`${api.theme}`, {
            headers: {
                Authorization: token,
                "Content-Type": "application/json",
            }
        })
    } catch (error) {
        if (error.response?.status === 401 || error.response?.status === 403) {
            const refreshToken = getRefreshToken();
            sessionStorage.setItem("intendedPage", `/theme`);
            if (!refreshToken) {
                alert("Session expired. Please log in again.");
                window.location.href = "/";
                return;
            }
            try {
                await refreshIdToken(refreshToken);
                await getExistingTheme();
            } catch (refreshErr) {
                console.error("Token refresh failed:", refreshErr);
                window.location.href = "/";
            }
        }
    }
}


export const saveTheme = async ({body}) => {
    const token = getTokenFromSession();
    try {
        return await axiosInstance.post(`${api.theme}`, body, {
            headers: {
                Authorization: token,
                "Content-Type": "application/json",
            }
        })
    } catch (error) {
        if (error.response?.status === 401 || error.response?.status === 403) {
            const refreshToken = getRefreshToken();
            sessionStorage.setItem("intendedPage", `/theme`);

            if (!refreshToken) {
                alert("Session expired. Please log in again.");
                window.location.href = "/";
                return;
            }
            try {
                await refreshIdToken(refreshToken);
                await saveTheme({body});
            } catch (refreshErr) {
                console.error("Token refresh failed:", refreshErr);
                window.location.href = "/";
            }
        }
    }
}


export const deleteTheme = async ({themeName}) => {
    const token = getTokenFromSession();
    try {
        return await axiosInstance.delete(`${api.theme}`, {
            headers: {
                Authorization: token,
                "Content-Type": "application/json",
            },
            params: {
                themeName: themeName,
            }
        })
    } catch (error) {
        if (error.response?.status === 401 || error.response?.status === 403) {
            const refreshToken = getRefreshToken();
            sessionStorage.setItem("intendedPage", `/theme`);

            if (!refreshToken) {
                alert("Session expired. Please log in again.");
                window.location.href = "/";
                return;
            }
            try {
                await refreshIdToken(refreshToken);
                await deleteTheme({themeName});
            } catch (refreshErr) {
                console.error("Token refresh failed:", refreshErr);
                window.location.href = "/";
            }
        }
    }
}
